"use client";

import { useGetUsersLazyQuery, User } from "@/graphql/generated/schema";
import { AutoComplete, Input, Spin } from "antd";

interface EmployeeSearchProps {
  selectedValue: User | null;
  onSelect: (value: User) => void;
}

export default function EmployeeSearch({
  selectedValue,
  onSelect,
}: EmployeeSearchProps) {
  const [employeeSearch, { data, loading }] = useGetUsersLazyQuery();

  const employeesData = data?.getUsers?.user || [];

  const options = employeesData.map((emp: User|null) => ({
    value: emp?.id,
    label: `${emp?.firstName} ${emp?.lastName}`,
    employee: emp,
  }));

  const handleSearch = (value: string) => {
    if (value.length < 2) return;

    employeeSearch({
      variables: { search: value },
    });
  };

  return (
    <AutoComplete
      value={
        selectedValue
          ? `${selectedValue.firstName} ${selectedValue.lastName}`
          : undefined
      }
      options={options}
      onSearch={handleSearch}
      onSelect={(_, option: any) => onSelect(option.employee)}
      notFoundContent={loading ? <Spin size="small" /> : null}
      style={{ width: "100%" }}
    >
      <Input placeholder="Search employee..." />
    </AutoComplete>
  );
}
